import { render, staticRenderFns } from "./DocumentsForm.vue?vue&type=template&id=df1a24de&"
import script from "./DocumentsForm.vue?vue&type=script&lang=ts&"
export * from "./DocumentsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports